export function request(email, newPassword, token) {
    return {
        type: 'USER_RESET_PASSWORD_REQUEST',
        email,
        newPassword,
        token
    };
}

export function error(errors) {
    return {
        type: 'USER_RESET_PASSWORD_ERROR',
        errors
    };
}

export function finish() {
    return {
        type: 'USER_RESET_PASSWORD_FINISH'
    };
}

export function clear() {
    return {
        type: 'USER_RESET_PASSWORD_CLEAR'
    };
}
